import { type StateCreator } from 'zustand';
import { create as actualCreate } from 'zustand';

const storeResetFns = new Set<() => void>();

export const resetAllStores = () => {
  storeResetFns.forEach((resetFn) => {
    resetFn();
  });
};

export const create = (<T extends { resetState: () => void }>(stateCreator: StateCreator<T>) => {
  const store = actualCreate(stateCreator);
  storeResetFns.add(store.getState().resetState);
  return store;
}) as typeof actualCreate;
